import React, { useEffect, useState } from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import SearchIcon from '@material-ui/icons/Search';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MoreIcon from '@material-ui/icons/MoreVert';
import StreamLogo from '../../../public/img/common/Logo1.png';
import './TopNav.less';
import { NavLink } from 'react-router-dom';
import store from '../../../store/appStore';
import { apiPost } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import Badge from '@material-ui/core/Badge';
import { Switch } from '../Switch';
import NotificationsActiveRoundedIcon from '@material-ui/icons/NotificationsActiveRounded';
import { toastType, ShowToast } from '../../../utils/toast-service';
import PendingNotification from './PendingNotification';
import { getNotificationMaster, getNotificationMasterData } from '../../../store/layout/actions';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  },
  search: {
    display: 'none',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto'
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch'
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}));

export default function PrimarySearchAppBar(props) {
  const [pendingNotifications, setPendingNotifications] = useState(props.pendingNotification || []);
  const [topTen, setTopTen] = useState([]);
  const [actionsOnTens, setActionsOnTens] = useState([]);
  const [reload, setReload] = useState(props.reload);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isAutoRunEnabled, setAutoRunEnableDisable] = useState(false);

  useEffect(() => {
    setNotificationMaster();
  }, [props.pendingNotification]);

  // Set Notification details in Notification Popup
  const setNotificationMaster = () => {
    const size = 10;
    const sorted = props?.pendingNotification?.sort((a, b) => {
      const aDate = new Date(a.createdDate);
      const bDate = new Date(b.createdDate);
      return bDate.getTime() - aDate.getTime();
    }) || [];

    const topTen = sorted.length > 10 ? sorted.slice(0, size) : sorted;
    const actionsOnTens = sorted.filter(x => x.isClickable === true && x.isRead !== true);

    setTopTen([]);
    setTopTen(topTen);
    setActionsOnTens(actionsOnTens);
    setReload(!reload);
    setNotificationCount(actionsOnTens.length);
  };

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const [notify, setNotify] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isNotifyMenuOpen = Boolean(notify);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  // Handle notifications
  const handleNotification = (event) => {
    setNotify(event.currentTarget);
  };

  // Close Notification Popup
  const handleNotifyClose = () => {
    setNotify(null);
  };

  // Delete all Notifications
  const clearArray = () => {
    setPendingNotifications([]);
    readAllNotification('Delete', true);
  };

  // Event to call readAllNotification method to mark all notifications status as Read
  const handleAllRead = (read) => {
    readAllNotification(read, true);
  };

  // Update status/flag of AutoRunPage settings
  const updateAutoRunPageStatus = (checked) => {
    apiPost({
      url: API_URL.Users.UpdateAutoRunPageStatus + '?isAutoRunEnabled=' + checked
    }).then(({ data }) => {
      if (data.success) {
        props.getUserData();
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
      }
    });
  }

  // Mark all notifications status as Read
  const readAllNotification = (read, isAll) => {
    const params = {
      notificationId: 0,
      isDeleteAll: isAll,
      action: read
    };
    apiPost({
      url: API_URL.Dashboard.UpdateNotificationAction,
      params: {},
      postBody: params
    }).then(({ data }) => {
      if (data.success) {
        if (read.toLowerCase() === 'delete') {
          ShowToast('Notifications deleted successfully', toastType.ERROR, 2000, 500);
        } else if (read.toLowerCase() === 'read') {
          ShowToast('Notifications marked as read ', toastType.SUCCESS, 2000, 500);
        } else if (read.toLowerCase() === 'unread') {
          ShowToast('Notifications marked as unread ', toastType.SUCCESS, 2000, 500);
        }

        if (isAll && read.toLowerCase() === 'read') {
          setNotificationCount(0);
        }
        // setIsAll(false);
        getNotificationMasterData();
        // props.handelReload && props.handelReload();
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
        getNotificationMasterData();
      }
    }).then(getNotificationMaster);
  };

  // Open Profile Popup
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle Mobile Menu Close
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  // Handle Menu Close
  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  // Open Mobile Menu
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  // Click event of switch button "Enable Auto Run". 
  // It will set true/false value to the variable isAutoRunEnabled
  // If the value is true, it will enable auto run of pages
  // If the value is false, it will not run the pages by default
  const enableDisableAutoRun = (checked) => {
    setAutoRunEnableDisable(checked);
    updateAutoRunPageStatus(checked);
  }

  let UserInitial = 'NA';
  const UserName = (((store.getState() || {}).auth || {}).account || {}).name || '';
  const emailId = (((store.getState() || {}).auth || {}).account || {}).username || '';
  const groupName = (((((store.getState() || {}).user || {}).userData || {}).groups || [])[0] || {}).configurationName || '';

  if (UserName !== '' || UserName !== '') {
    const matches = UserName.match(/\b(\w)/g);
    UserInitial = matches.join('');
  } else {
    UserInitial = '';
  }

  // Set Auto Run flag
  useEffect(() => {
    setAutoRunEnableDisable(((props?.userData?.userMarket || [])[0] || {}).autoRunPages || false);
  }, props?.userData?.userMarket);

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      style={{ marginTop: '30px' }}
    >
      <div className="user-initial-inner">{UserInitial}</div>
      {UserName && <div className="user-details-inner">{UserName}</div>}
      <div className="user-details-inner">{emailId}</div>
      <div className="user-details-inner">{groupName}</div>
      <div className="user-details-inner">{''}</div>
      <div className="user-details-inner">
        <Switch
          isChecked={isAutoRunEnabled}
          onChangeValues={(checked, key) => {
            enableDisableAutoRun(checked);
          }}
          id={'switch_is_autorun_enabled_id'}
          // startLabelText={'Enable Auto Run'}
          labelText={'Enable Auto Run'}
          fullWidth
          alignCenter={true}
        />
      </div>
      <MenuItem
        onClick={(handleMenuClose, props.logout)}
        style={{ paddingLeft: '35%' }}
      >
        Sign Out
      </MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        Hi
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Sign Out</p>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static" className={'appbar-background'}>
        <Toolbar className={'topnav-padding'}>
          <NavLink
            to={
              '/pendingRequests'
            }
          >
            <img src={StreamLogo} alt="logo" className={'stream-logo'} />
          </NavLink>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
          </div>
          <div
            className={classes.grow + ' app-header-white'}
            style={{
              fontSize: '18px',
              textAlign: 'center',
              textTransform: 'uppercase',
              fontWeight: '500',
              color: '#FFFFF !important'
            }}
          >
            Stream Allocation System
          </div>
          <div className={classes.sectionDesktop}>
            <div style={{ marginTop: '12px' }}>
              <div className='action-item'>
                <Badge badgeContent={notificationCount || 0} color="secondary" size="medium" style={{ cursor: 'pointer' }}>
                  <NotificationsActiveRoundedIcon onClick={handleNotification} />
                </Badge>
              </div>

              <Menu
                id="simple-menu"
                anchorEl={notify}
                keepMounted
                open={isNotifyMenuOpen}
                onClose={handleNotifyClose}
                className="notification-menu"
              >
                <div className="">
                  {topTen.length > 0 && topTen.map(x => <PendingNotification
                    key={x.notificationMasterId}
                    recordId={x.notificationMasterId}
                    parentRecordId={x.parentRecordId}
                    module={x.module}
                    header={x.feature}
                    createdBy={x.createdBy}
                    createdDate={x.createdDate}
                    message={x.notification}
                    isClickable={x.isClickable}
                    onClick={handleNotifyClose}
                    isRead={x.isRead}
                    handleRefresh={getNotificationMaster}
                  />)}
                </div>
                <div className='action-on-notification'>
                  {topTen.length > 0
                    ? (<>
                      <NavLink style={{ cursor: 'pointer', fontSize: '0.768rem' }} to={'/pendingNotifications'}>
                        {<span onClick={handleNotifyClose}>{'View All'}</span>}
                      </NavLink>
                      <p style={{ cursor: 'pointer', fontSize: '0.768rem' }} onClick={() => handleAllRead('Read')} >{'Mark All as Read'}</p>
                      <p style={{ cursor: 'pointer', fontSize: '0.768rem' }} onClick={() => handleAllRead('Unread')} >{'Mark All as Unread'}</p>
                      <NavLink style={{ cursor: 'pointer', fontSize: '0.768rem' }} to={'/pendingNotifications'} onClick={clearArray}>
                        {<span onClick={handleNotifyClose}>{'Delete All'}</span>}
                      </NavLink>
                    </>)
                    : 'No Pending Notifications'}
                </div>
              </Menu>
            </div>
            <div>
              <IconButton
                edge="end"
                aria-label="User Profile"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
                size="medium"
                className="iconbutton-extend"
              >
                <span className="user-initial">{UserInitial}</span>
              </IconButton>
            </div>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
